const DAYS_OF_WEEK_MAP = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
};

export default DAYS_OF_WEEK_MAP;



// WEBPACK FOOTER //
// ./src/daysOfWeekMap.js